'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _tree = require('./tree');

var _tree2 = _interopRequireDefault(_tree);

var _node = require('./node');

var _node2 = _interopRequireDefault(_node);

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UITree = function (_Component) {
  _inherits(UITree, _Component);

  function UITree(props) {
    _classCallCheck(this, UITree);

    var _this = _possibleConstructorReturn(this, (UITree.__proto__ || Object.getPrototypeOf(UITree)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = _this.init(props);
    _this.state.dragging = {
      id: null,
      x: null,
      y: null,
      w: null,
      h: null
    };
    return _this;
  }

  _createClass(UITree, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.tree != this.props.tree || nextProps.searchTerm != this.props.searchTerm) {
        this.setState(this.init(nextProps));
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.searchTerm && prevProps.searchTerm != this.props.searchTerm) {
        this.setState(this.init(this.props));
      }
    }
  }, {
    key: 'nodeMatches',
    value: function nodeMatches(node, searchTerm, dateFilter) {
      if (node.type != 'experiment') {
        return false;
      }

      // Active experiment node never matches
      if (node.type === 'experiment' && node.id === -1) {
        return false;
      }

      if (dateFilter) {
        var datePart = dateFilter.toISOString().match(/[-\d]*T/)[0];
        if (node.t_zero && node.t_zero.indexOf(datePart) !== 0) {
          return false;
        }
        if (node.created && node.created.indexOf(datePart) !== 0) {
          return false;
        }

        // Date matched, and there is no other search keyword
        if (!searchTerm) {
          return true;
        }
      }

      var lowercaseTerm = searchTerm.toLowerCase();

      if (node.module.toLowerCase().indexOf(lowercaseTerm) != -1) {
        return true;
      }

      if (node.tags) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = node.tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var tag = _step.value;

            if (tag.toLowerCase().indexOf(lowercaseTerm) != -1) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      return false;
    }
  }, {
    key: 'recursiveFilter',
    value: function recursiveFilter(tree, sensorFilter) {

      var filterChildren = function filterChildren(node) {

        var newNode = Object.assign({}, node);
        var match = false;
        if (!newNode.module) {
          return false;
        }

        if (newNode.children) {
          newNode.children = newNode.children.map(function (child) {
            return filterChildren(child);
          }).filter(function (child) {
            return child != false;
          });
        }

        if (newNode.type == 'sensor') {
          var sensorName = newNode.module;
          if (sensorName) {
            if (sensorName.toLowerCase().indexOf(sensorFilter.toLowerCase()) != -1) {
              match = true;
            }
          }
        }

        if (newNode.type == 'folder' || newNode.type == 'experiment') {
          match = true;
        }

        if (match) {
          return newNode;
        } else {
          return false;
        }
      };

      if (!tree.children) return tree;
      if (!sensorFilter || sensorFilter.length == 0) return tree;
      tree = filterChildren(tree);
      return tree;
    }
  }, {
    key: 'canDropInPosition',
    value: function canDropInPosition(node, dropTarget) {
      if (!this.props.canDropInPosition) return true;
      var originalParent = this.state.parentBeforeDrag.node;
      return this.props.canDropInPosition(node, originalParent, dropTarget);
    }
  }, {
    key: 'canDropInto',
    value: function canDropInto(node, dropTarget) {
      var originalParent = this.state.parentBeforeDrag.node;
      if (originalParent === dropTarget) {
        return false;
      }
      return this.props.canDropInto(node, dropTarget);
    }
  }, {
    key: 'render',
    value: function render() {
      var tree = this.state.tree;
      var dragging = this.state.dragging;
      var dropTarget = this.state.dropTarget;
      var draggingDom = this.getDraggingDom();

      if (this.state.dateInvalid) {
        return _react2.default.createElement(
          'div',
          { className: 'tree-notice' },
          'Could not recognize date "',
          this.state.dateInvalid,
          '". Please use the following format: YYYY-MM-DD (e.g. 2018-09-24).'
        );
      }

      if (tree.obj && tree.obj.children && tree.obj.children.length == 0 && this.props.searchTerm) {
        return _react2.default.createElement(
          'div',
          { className: 'tree-notice' },
          ' No experiments found matching these keywords. '
        );
      }

      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)('m-tree', {
            'dragging': this.state.dragging.id,
            'drop-target-active': this.state.dropTarget
          })
        },
        draggingDom,
        _react2.default.createElement(_node2.default, {
          tree: tree,
          index: tree.getIndex(1),
          key: 1,
          paddingLeft: this.props.paddingLeft,
          onDragStart: this.dragStart,
          onCollapse: this.toggleCollapse,
          dragging: dragging && dragging.id,
          dropTarget: dropTarget,
          canDrag: this.props.canDrag
        })
      );
    }
  }, {
    key: 'moveHelper',
    value: function moveHelper(fromId, toId, placement, targetStorage) {
      targetStorage.toId = toId;
      targetStorage.placement = placement;
      return this.state.tree.move(fromId, toId, placement);
    }
  }, {
    key: 'findUnfilteredExperimentNode',


    // find node index id in unfiltered tree
    value: function findUnfilteredExperimentNode(externalId) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = Object.keys(this.state.unfilteredTree.indexes)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var i = _step2.value;

          var index = this.state.unfilteredTree.indexes[i];
          if (index.node.type !== 'sensor' && index.node.id === externalId) {
            return index;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }]);

  return UITree;
}(_react.Component);

UITree.propTypes = {
  tree: _propTypes2.default.object.isRequired,
  paddingLeft: _propTypes2.default.number,
  renderNode: _propTypes2.default.func.isRequired
};
UITree.defaultProps = {
  paddingLeft: 20
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.init = function (props) {
    var treeObj = Object.assign({}, props.tree);

    if (props.searchTerm) {
      var searchTerm = props.searchTerm;

      var sensorMatch = searchTerm.match(/sensor:([^ ]*)/);
      var sensorFilter = void 0;
      if (sensorMatch) {
        sensorFilter = sensorMatch[1];
      }

      treeObj = _this2.recursiveFilter(treeObj, sensorFilter);
    }
    var tree = new _tree2.default(treeObj);

    tree.isNodeCollapsed = props.isNodeCollapsed;
    tree.renderNode = props.renderNode;
    tree.renderTags = props.renderTags;
    tree.changeNodeCollapsed = props.changeNodeCollapsed;
    tree.getIcon = props.getIcon;
    tree.onDelete = props.onDelete;
    tree.onEdit = props.onEdit;
    tree.onAdd = props.onAdd;
    tree.onView = props.onView;
    tree.canDropInPosition = _this2.canDropInPosition.bind(_this2);
    tree.updateNodesPosition();

    var treecopy = (0, _lodash2.default)(props.tree);
    var unfilteredTree = new _tree2.default(treecopy);
    unfilteredTree.updateNodesPosition();

    return {
      tree: tree,
      unfilteredTree: unfilteredTree,
      dateInvalid: null
    };
  };

  this.getDraggingDom = function () {
    var _state = _this2.state,
        tree = _state.tree,
        dragging = _state.dragging;


    if (dragging && dragging.id) {
      var draggingIndex = tree.getIndex(dragging.id);
      var draggingStyles = {
        top: dragging.y,
        left: dragging.x,
        width: dragging.w
      };

      return _react2.default.createElement(
        'div',
        { className: 'm-draggable', style: draggingStyles },
        _react2.default.createElement(_node2.default, {
          tree: tree,
          index: draggingIndex,
          paddingLeft: _this2.props.paddingLeft
        })
      );
    }

    return null;
  };

  this.dragStart = function (id, dom, e) {
    console.log("react-ui-tree dragStart()");

    var tree = _this2.state.tree;
    var index = tree.getIndex(id);

    _this2.setState({
      indexBeforeDrag: index,
      parentBeforeDrag: tree.getIndex(index.parent)
    });

    if (e.button !== 0) return;

    // what are we dragging
    _this2.dragging = {
      id: id,
      w: dom.offsetWidth,
      h: dom.offsetHeight + 2,
      x: dom.offsetLeft,
      y: dom.offsetTop
    };

    // where are we dragging it
    _this2._startX = dom.offsetLeft;
    _this2._startY = dom.offsetTop;
    _this2._offsetX = e.clientX;
    _this2._offsetY = e.clientY;
    _this2._start = true;

    window.addEventListener('mousemove', _this2.drag);
    window.addEventListener('mouseup', _this2.dragEnd);
  };

  this.drag = function (e) {

    // what if we're starting
    if (_this2._start) {
      _this2.setState({
        dragging: _this2.dragging
      });
      _this2._start = false;
    }

    var tree = _this2.state.tree;
    var dragging = _this2.state.dragging;
    var paddingLeft = _this2.props.paddingLeft;
    var newIndex = null;
    var index = tree.getIndex(dragging.id);
    var collapsed = index.node.collapsed;
    var lastMoveTarget = { toId: null, placement: null };
    var dropTarget = null;

    var _startX = _this2._startX;
    var _startY = _this2._startY;
    var _offsetX = _this2._offsetX;
    var _offsetY = _this2._offsetY;

    // This is the absolute dragging diff coords based on the starting point
    var pos = {
      x: _startX + e.clientX - _offsetX,
      y: _startY + e.clientY - _offsetY
    };
    dragging.x = pos.x;
    dragging.y = pos.y;

    // This is the position based on where the currently dragging object
    // has been moved to in the drag hover process
    var diffX = dragging.x - paddingLeft / 2 - (index.left - 2) * paddingLeft;
    var diffY = dragging.y - dragging.h / 2 - (index.top - 2) * dragging.h;

    if (diffX < 0) {
      // left
      // added override to not be able to move to hidden root folder
      if (index.parent && !index.next && index.parent != 1 && !_this2.state.dropTarget) {
        // moving left, move node after the current parent
        newIndex = _this2.moveHelper(index.id, index.parent, 'after', lastMoveTarget);
      }
    } else if (diffX > paddingLeft) {
      // right
      if (index.prev) {
        var prevNode = tree.getIndex(index.prev).node;
        // We add an exception for when we're already hovering over a folder in 
        // drop target mode. Other wise the node would pop upwards during hover
        if (!prevNode.collapsed && !prevNode.leaf && !_this2.state.dropTarget) {
          // moving right, append to end of previous element
          newIndex = _this2.moveHelper(index.id, index.prev, 'append', lastMoveTarget);
        }
      }
    }

    if (newIndex) {
      index = newIndex;
      newIndex.node.collapsed = collapsed;
      dragging.id = newIndex.id;
    }

    if (diffY < 0) {
      // up
      var above = tree.getNodeByTop(index.top - 1);

      // The drop zone is 75% of the height of the element we're dropping into.
      // If we drag past 75% of the height, we go out of the drop zone, back to 
      // swapping, so the element will land after / before whatever we're targeting.
      var isStillInDropZoneAbove = function isStillInDropZoneAbove() {
        return diffY > -(0.75 * dragging.h);
      };

      // if we're dragging up, and the node above is a folder, and we have
      // not moved past this folder yet, don't do a swap, just highlight the
      // folder for a drop.
      if (above && _this2.canDropInto(index.node, above.node) && isStillInDropZoneAbove()) {
        dropTarget = above.id;
      } else {
        // moving up, move before the element above
        newIndex = _this2.moveHelper(index.id, above.id, 'before', lastMoveTarget);
      }
    } else if (diffY > dragging.h) {
      // down
      var isStillInDropZoneBelow = function isStillInDropZoneBelow() {
        return diffY < 1.75 * dragging.h;
      };

      if (index.next) {
        var below = tree.getIndex(index.next);

        if (below && _this2.canDropInto(index.node, below.node) && isStillInDropZoneBelow()) {
          dropTarget = below.id;
        } else {
          if (below.children && below.children.length && !below.node.collapsed) {
            // moving down, append to beginning of next element if it's an open folder
            newIndex = _this2.moveHelper(index.id, index.next, 'prepend', lastMoveTarget);
          } else {
            // or just move after next element if it's not a folder
            newIndex = _this2.moveHelper(index.id, index.next, 'after', lastMoveTarget);
          }
        }
      } else {
        // Dragging down, but node has no "next" sibling: It's the last node
        // in the set of children and below it we're going one level up
        var _below = tree.getNodeByTop(index.top + index.height);

        if (_below && _this2.canDropInto(index.node, _below.node) && isStillInDropZoneBelow()) {
          dropTarget = _below.id;
        } else {
          if (_below && _below.parent !== index.id) {
            if (_below.children && _below.children.length && !_below.node.collapsed) {
              // Append to beginning of element below if it's a folder and is open
              newIndex = _this2.moveHelper(index.id, _below.id, 'prepend', lastMoveTarget);
            } else {
              // append after the element below if it's not a folder
              newIndex = _this2.moveHelper(index.id, _below.id, 'after', lastMoveTarget);
            }
          }
        }
      }
    }

    // console.log("Drop target is now ", dropTarget);

    if (newIndex) {
      newIndex.node.collapsed = collapsed;
      dragging.id = newIndex.id;
    }

    var newState = {
      tree: tree,
      dragging: dragging,
      dropTarget: dropTarget
    };

    if (lastMoveTarget.placement) {
      newState.lastMoveTarget = lastMoveTarget;
    }

    _this2.setState(newState);
  };

  this.dragEnd = function () {
    console.log("react-ui-tree dragEnd()");
    var tree = _this2.state.tree;
    var index = tree.getIndex(_this2.state.dragging.id);

    _this2.setState({
      dragging: {
        id: null,
        x: null,
        y: null,
        w: null,
        h: null
      }
    });

    window.removeEventListener('mousemove', _this2.drag);
    window.removeEventListener('mouseup', _this2.dragEnd);

    if (index) {
      var node = index.node;
      var parent = index.parent ? tree.getIndex(index.parent).node : null;
      var prev = index.prev ? tree.getIndex(index.prev).node : null;
      var next = index.next ? tree.getIndex(index.next).node : null;

      if (_this2.state.dropTarget) {
        var dropTargetIndex = tree.getIndex(_this2.state.dropTarget);
        _this2.state.tree.move(index.id, _this2.state.dropTarget, 'prepend');
        _this2.fireChangeEvent({ toId: _this2.state.dropTarget, placement: 'prepend' });

        _this2.setState({ dropTarget: null });
      } else if (_this2.canDropInPosition(node, parent)) {
        _this2.fireChangeEvent();
      } else {
        var indexBeforeDrag = _this2.state.indexBeforeDrag;
        // if nothing moved, we're done!
        if (indexBeforeDrag == index) {
          return;
        }

        // if the old Index had a previous node, use that to insert
        if (indexBeforeDrag.prev) {
          tree.move(index.id, indexBeforeDrag.prev, 'after');
        } else if (indexBeforeDrag.next) {
          // or if it has a next, use that
          tree.move(index.id, indexBeforeDrag.next, 'before');
          // or it must be the sole child of it's parent, so use the parent
        } else {
          tree.move(index.id, indexBeforeDrag.parent, 'append');
        }

        _this2.setState({ needsUpdate: Math.random() });
      }
    }
  };

  this.fireChangeEvent = function (moveTarget) {
    if (!moveTarget) {
      moveTarget = _this2.state.lastMoveTarget;
    }

    if (!_this2.props.onChange || !moveTarget) {
      return;
    }

    // In case a search filter is currently applied, we maintain a full 
    // copy of the unfiltered tree, and synchronize the position of the
    // nodes when they are moved through drag & drop. Then we can fire 
    // the change event using the full tree.

    var tree = _this2.state.tree;
    var fromExternalNode = _this2.state.indexBeforeDrag.node;
    var toExternalNode = tree.get(moveTarget.toId);

    var placement = moveTarget.placement;
    var nodeFrom = _this2.findUnfilteredExperimentNode(fromExternalNode.id);
    var nodeTo = _this2.findUnfilteredExperimentNode(toExternalNode.id);

    _this2.state.unfilteredTree.move(nodeFrom.id, nodeTo.id, placement);

    var changeEvent = { from: fromExternalNode, to: toExternalNode, placement: placement };

    _this2.props.onChange(_this2.state.unfilteredTree.obj, changeEvent);
  };

  this.toggleCollapse = function (nodeId) {
    var tree = _this2.state.tree;
    var index = tree.getIndex(nodeId);
    var node = index.node;
    node.collapsed = !node.collapsed;
    tree.updateNodesPosition();

    _this2.setState({
      tree: tree
    });

    if (_this2.props.onCollapse) {
      _this2.props.onCollapse(node);
    }
  };
};

module.exports = UITree;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-ui-tree/dist/react-ui-tree.js
// module id = 1302
// module chunks = 2